import "./PrivacyPolicy.module.css";
import Header from "@/reusable_sections/Header";
import PrivacyPolicyContent from "./sections/PrivacyPolicyContent";
import Privacypolicyfooter from "./sections/Privacypolicyfooter";
export default function PrivacyPolicyPage() {
  return <div>
      <Header />
      <PrivacyPolicyContent />
      <Privacypolicyfooter />
    </div>;
}